import * as angular from "angular";
import { formatArrayTableCell } from "./arrayTableModel";

export function getArrayTableItemTitle(form) {
	return form.schema.items.title || (form.title ? `${form.title} Entry` : "Entry");
}

export function applyArrayTableItem(scope, sfSelect, index, item) {
	let model = scope.modelArray;
	if(!Array.isArray(model)) {
		model = [];
		sfSelect(scope.form.key, scope.model, model);
		scope.modelArray = model;
	}

	const itemCopy = angular.copy(item);
	if(index === undefined) {
		model.push(itemCopy);
	}
	else {
		model.splice(index, 1, itemCopy);
	}

	scope.ngModel?.$setDirty?.();
	scope.validateField?.();
	return itemCopy;
}

export function removeArrayTableItem(scope, sfSelect, index, restoreAbsentArray) {
	scope.deleteFromArray(index);
	if(restoreAbsentArray && scope.modelArray?.length === 0) {
		const parentPath = scope.form.key.slice(0, -1);
		const parent = parentPath.length > 0
			? sfSelect(parentPath, scope.model)
			: scope.model;
		delete parent[scope.form.key[scope.form.key.length - 1]];
		scope.modelArray = undefined;
	}

	scope.ngModel?.$setDirty?.();
	scope.validateField?.();
}

export function openArrayTableItem(scope, $uibModal, sfSelect, index?: number) {
	const isNew = index === undefined;
	const itemModel = isNew ? {} : angular.copy(scope.modelArray[index]);
	return $uibModal.open({
		component: "schema-array-item-modal",
		size: "lg",
		backdrop: "static",
		keyboard: false,
		resolve: {
			title: () => getArrayTableItemTitle(scope.form),
			schema: () => scope.form.schema.items,
			model: () => itemModel,
			isNew: () => isNew
		}
	}).result.then(
		item => applyArrayTableItem(scope, sfSelect, index, item),
		() => undefined
	);
}

export function schemaFormArrayTable($uibModal, sfSelect) {
	return {
		restrict: "A",
		link(scope) {
			let createdArray;
			scope.addArrayTableItem = () => {
				const hadArray = Array.isArray(sfSelect(scope.form.key, scope.model));
				return openArrayTableItem(scope, $uibModal, sfSelect).then(item => {
					if(item !== undefined && !hadArray) {
						createdArray = scope.modelArray;
					}
					return item;
				});
			};
			scope.editArrayTableItem = index => openArrayTableItem(scope, $uibModal, sfSelect, index);
			scope.removeArrayTableItem = index => {
				const restoreAbsentArray = scope.modelArray === createdArray;
				removeArrayTableItem(scope, sfSelect, index, restoreAbsentArray);
				if(restoreAbsentArray && scope.modelArray === undefined) {
					createdArray = undefined;
				}
			};
			scope.formatArrayTableCell = formatArrayTableCell;
		}
	};
}

schemaFormArrayTable.$inject = ["$uibModal", "sfSelect"];

export default angular
	.module("vesl.extensions.json-schema.schema-form-array-table", [])
	.directive("schemaFormArrayTable", schemaFormArrayTable)
	.name;
